<template>
  <div class="user-info-wrapper">
    <user-info-detail :value="user" @preview="toggleQrcode" />
    <user-info-list :links="links" />
    <van-overlay :show="qrcodeShown" @click="toggleQrcode">
      <div class="qrcode-wrapper" @click.stop>
        <div class="qrcode">
          <div class="qrcode" ref="qrCodeUrl"></div>
          <!-- {{ user.card }} -->
          <!-- <van-image :src="user.qrcode" /> -->
        </div>
        <!-- <div class="tips-wrapper">
          <p>您的小时卡余额为{{ user.hours }}</p>
          <p class="tip">可在店内消费￥{{ user.hours * 100 }}</p>
        </div> -->
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import QRCode from 'qrcodejs2';
import UserInfoDetail from './UserInfoDetail';
import UserInfoList from './UserInfoList';

export default {
  components: {
    UserInfoDetail,
    UserInfoList,
  },
  data() {
    return {
      qrcodeShown: false,
    };
  },
  computed: {
    ...mapGetters(['user']),
    links() {
      const colors = ['#f38181', '#fce38a', '#eaffd0', '#95e1d3'];
      const links = [
        [
          {
            icon: 'qr',
            color: colors[0],
            title: '会员二维码',
            notLink: true,
            action: this.toggleQrcode,
          },
          {
            icon: 'bill-o',
            color: colors[1],
            title: '会员充值',
            path: '/user_info/recharge',
          },
          // {
          //   icon: 'coupon-o',
          //   color: colors[1],
          //   title: '赠票领取',
          //   path: '/user_info/bonus_scan',
          // },
        ],
        [
          {
            icon: 'records',
            color: colors[2],
            title: '充值记录',
            path: '/user_info/recharge_list',
          },
          {
            icon: 'records',
            color: colors[3],
            title: '消费记录',
            path: '/user_info/consume_list',
          },
        ],
        // [
        //   {
        //     icon: 'records',
        //     color: colors[0],
        //     title: '返利记录',
        //     path: '/user_info/hours_rebate_list',
        //   },
        //   {
        //     icon: 'records',
        //     color: colors[1],
        //     title: '参赛记录',
        //     path: '/user_info/participation_list',
        //   },
        // ],
        // [
        //   {
        //     icon: 'records',
        //     color: colors[2],
        //     title: '余额变更记录',
        //     path: '/user_info/balance_list',
        //   },
        //   {
        //     icon: 'records',
        //     color: colors[3],
        //     title: '积分变更记录',
        //     path: '/user_info/integral_list',
        //   },
        //   {
        //     icon: 'records',
        //     color: colors[0],
        //     title: '小时卡变更记录',
        //     path: '/user_info/hours_list',
        //   },
        // ],
      ];
      const extraLinks = [
        {
          icon: 'balance-o',
          color: colors[2],
          title: '提现',
          path: '/user_info/withdraw',
        },
        {
          icon: 'share',
          color: colors[3],
          title: '分享链接',
          path: '/user_info/share',
        },
        {
          icon: 'after-sale',
          color: colors[0],
          title: '返利记录',
          path: '/user_info/rebate_list',
        },
      ];
      // return links
      const { more } = this.user;
      return more === 1 ? [...links, extraLinks] : links;
    },
  },
  created() {
    this.getUser();
  },
  mounted() {
    this.creatQrCode();
  },
  methods: {
    ...mapActions(['getUser']),
    toggleQrcode() {
      this.qrcodeShown = !this.qrcodeShown;
    },
    creatQrCode() {
      const qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.user.card, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      });
      console.log(qrcode);
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-wrapper {
  margin-bottom: 50px;
  .qrcode-wrapper {
    text-align: center;
    background: #fff;
    padding: 24px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    overflow: hidden;
    .tips-wrapper {
      color: #999;
      font-size: 14px;
      margin: 24px 0 0;
      .tip {
        margin: 8px;
      }
    }
  }
}
</style>
